import { Link } from "react-router-dom";
import { useAppSelector } from "../../../redux/store";
import LogService from "../../../services/LogService";
import { encrypt } from "../../../utils/crypto";
import { useTranslation } from "react-i18next";
import CustomModal from "../../../components/CustomModal";
import { useState } from "react";
import Faq from "../../../components/Faq";

const NoEmailsBtn = () => {
  const booking = useAppSelector((state) => state.booking);
  const [modalIsShown, setModalIsShown] = useState(false);
  const { t } = useTranslation();

  return (
    <>
      <button
        className="btnRounded w-100"
        onClick={() => setModalIsShown(true)}
      >
        {booking.hasOpenedTask
          ? t("buttons.communicate")
          : t("buttons.questions")}
      </button>
      <CustomModal
        isOpen={modalIsShown}
        onRequestClose={() => setModalIsShown(false)}
      >
        <Faq />
      </CustomModal>
    </>
  );
};

export default NoEmailsBtn;
